"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function appendPath(baseUrl, path) {
    var lastChar = baseUrl[baseUrl.length - 1];
    if (lastChar === '/') {
        return baseUrl + path;
    }
    return baseUrl + '/' + path;
}
exports.appendPath = appendPath;
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function normalizeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
exports.normalizeAccents = normalizeAccents;
exports.StringBase = {
    appendPath: appendPath,
    normalizeAccents: normalizeAccents,
};
//# sourceMappingURL=string.js.map